import { StockDto } from "src/dtos/stock/stockDto";

// 소계 관련 상수 정의
export const PUR5010_R01_SUBTOTAL_TYPES = {
    ITEM: 'item',
    WAREHOUSE: 'warehouse',
    BRAND: 'brand',
} as const;

// 소계 계산을 위한 그룹화 및 집계 필드 설정
export const PUR5010_R01_SUBTOTAL_LEVELS = {
    ITEM: 1,
    WAREHOUSE: 2,
    BRAND: 3,
    DETAIL: 4,
} as const;

// 품목별 소계 데이터 인터페이스
export interface PUR5010_R01ItemSubtotalData extends StockDto {
    count: number;
}

// 창고별 소계 데이터 인터페이스
export interface PUR5010_R01WarehouseSubtotalData extends PUR5010_R01ItemSubtotalData {
    groupKey?: string;
}

// 브랜드별 소계 데이터 인터페이스
export interface PUR5010_R01BrandSubtotalData extends PUR5010_R01ItemSubtotalData {
    groupKey?: string;
}

// 소계 행 인터페이스들
export interface PUR5010_R01ItemSubtotalRow extends StockDto {
    isSubtotal: true;
    subtotalType: typeof PUR5010_R01_SUBTOTAL_TYPES.ITEM;
    level: typeof PUR5010_R01_SUBTOTAL_LEVELS.ITEM;
    groupKey: string;
    groupLabel: string;
    count: number;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
}

export interface PUR5010_R01WarehouseSubtotalRow extends StockDto {
    isSubtotal: true;
    subtotalType: typeof PUR5010_R01_SUBTOTAL_TYPES.WAREHOUSE;
    level: typeof PUR5010_R01_SUBTOTAL_LEVELS.WAREHOUSE;
    groupKey: string;
    groupLabel: string;
    count: number;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    logicCenter: string;
    logicCenterNm: string;
    warehouseCd: string;
    warehouseNm: string;
}

export interface PUR5010_R01BrandSubtotalRow extends StockDto {
    isSubtotal: true;
    subtotalType: typeof PUR5010_R01_SUBTOTAL_TYPES.BRAND;
    level: typeof PUR5010_R01_SUBTOTAL_LEVELS.BRAND;
    groupKey: string;
    groupLabel: string;
    count: number;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    brandCd: string;
    brandNm: string;
    logicCenter: string;
    logicCenterNm: string;
    warehouseCd: string;
    warehouseNm: string;
}

// 백엔드 PUR5010_R01Dto(StockDto 기반)와 프론트 상세행 공통 타입
export interface PUR5010_R01StockDto extends StockDto {
    compCd?: string;
    compNm?: string;
    brandCd?: string;
    brandNm?: string;
    itemGroup?: string;
    itemAccount?: string;
    orderTypeNm?: string;
    workplaceNm?: string;
    jobTeamNm?: string;
    empNm?: string;
    listLength?: number;
    refetchListLength?: number;
	locationCd?: string;
	locationNm?: string;
	isSubtotal?: false;
    level?: typeof PUR5010_R01_SUBTOTAL_LEVELS.DETAIL;
}

// 통합 그리드 데이터 타입
export type PUR5010_R01Dto =
    | PUR5010_R01ItemSubtotalRow
    | PUR5010_R01WarehouseSubtotalRow
    | PUR5010_R01BrandSubtotalRow
	| PUR5010_R01StockDto;

// 그리드 기본 행 데이터(상세행 기본값)
export const defaultPUR5010_R01Dto: PUR5010_R01Dto =  {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	compCd: '',
	compNm: '',
    brandCd: '',
    brandNm: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',
	itemUnit: '',
	logicCenter: '',
    logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	stockQty: 0,
	reservQty: 0,
	availableQty: 0,

	
	inserted: false,
	isModified: false,
};
